// extracted by mini-css-extract-plugin
module.exports = {"Container":"Coin_Container__2-OX-","Result":"Coin_Result__2-_Sz"};